import React from 'react';
import { useFormik } from 'formik';
import useTranslation from 'next-translate/useTranslation';

import Axios from '@/utils/axios';
import { Button, RadioWithTitle, TariffCard } from '@/ui/index';

import styles from './styles.module.scss';

const FindBundleForm = ({ data }) => {
  const { lang } = useTranslation();

  const questionsRef = React.useRef({});
  const [tariff, setTariff] = React.useState(null);

  const scrollToNextPage = React.useCallback(() => {
    questionsRef.current.gallery.scrollBy({
      top: 0,
      left: questionsRef.current['0']?.clientWidth,
      behavior: 'smooth',
    });
  }, [questionsRef]);

  const formik = useFormik({
    initialValues: {
      answers: [],
    },
  });

  const getFittedTariff = async (data) => {
    try {
      const tariff = await Axios.post(
        'tariffs/choice/',
        {
          answers: data,
        },
        {
          headers: {
            'Accept-Language': lang,
          },
        },
      );
      setTariff(tariff.data);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
  };

  React.useEffect(() => {
    if (data?.questions?.length === formik?.values?.answers?.length) {
      getFittedTariff(formik?.values?.answers);
    }
  }, [data?.questions?.length, formik?.values?.answers]);

  const renderQuestion = (item, index) => {
    const radioOnChange = (id) => {
      formik.setFieldValue(`answers.${index}`, id);
    };

    return (
      <div
        ref={(ref) => (questionsRef.current[index] = ref)}
        className={styles.question}
        key={index}
        itemScope
        itemType='http://schema.org/Article'
      >
        <span className={styles.title}>{item.text}</span>
        <div className={styles.content}>
          {item.answers.map((checkbox, checkboxIndex) => (
            <RadioWithTitle
              checked={formik.values.answers.includes(checkbox.id)}
              onChange={() => radioOnChange(checkbox.id)}
              name={`${index}_question`}
              key={`${checkboxIndex}_question`}
              className={styles.input}
            >
              {checkbox.text}
            </RadioWithTitle>
          ))}
        </div>
      </div>
    );
  };

  if (tariff) {
    return (
      <div itemScope itemType='http://schema.org/Offer'>
        <span className={styles.title}>
          {tariff.name}
          <span className={styles.red}>{data?.result_title}</span>
        </span>
        <div className={styles.tariff}>
          <TariffCard item={tariff} />
        </div>
      </div>
    );
  }

  return (
    <div itemScope itemType='http://schema.org/WebPage'>
      <span className={styles.title}>
        <div dangerouslySetInnerHTML={{ __html: data?.title }} />
      </span>
      <div
        className={styles.slider}
        ref={(ref) => (questionsRef.current.gallery = ref)}
      >
        {data?.questions?.map(renderQuestion)}
      </div>
      <div className={styles.button}>
        <Button onClick={scrollToNextPage}>Next</Button>
      </div>
    </div>
  );
};

export default FindBundleForm;
